import React from "react";
import PropTypes from "prop-types";
import { Link, graphql, StaticQuery } from "gatsby";
import PreviewCompatibleImage from "./PreviewCompatibleImage";
import { HTMLContent } from "./Content";

const BlogLatest = ({ data }) => {
  const { edges } = data.allMarkdownRemark;
  const post = edges[0].node;
  const PostContent = HTMLContent || post.excerpt;

  return (
    <>
      <Link
        className="has-text-grey-dark has-text-weight-bold"
        to={post.fields.slug}
        style={{
          fontSize: "1.1rem",
        }}
      >
        {post.frontmatter.title}
      </Link>
      <span
        className="has-text-grey is-block m-b-sm"
        style={{
          fontSize: "0.9rem ",
        }}
      >
        {post.frontmatter.date}
      </span>
      <div>
        <PostContent className="disable-links" content={post.excerpt} />
        <div className="field is-grouped is-grouped-left m-t-md">
          <Link className="button is-light" to={post.fields.slug}>
            Keep Reading →
          </Link>
          {/* <Link className="button is-light m-l-md" to="/blog">
            Browse All Posts →
          </Link> */}
        </div>
      </div>
    </>
  );
};

BlogLatest.propTypes = {
  data: PropTypes.shape({
    allMarkdownRemark: PropTypes.shape({
      edges: PropTypes.array,
    }),
  }),
};

export default () => (
  <StaticQuery
    query={graphql`
      query BlogLatestQuery {
        allMarkdownRemark(
          sort: { order: DESC, fields: [frontmatter___date] }
          filter: { frontmatter: { templateKey: { eq: "blog-post" } } }
          limit: 1
        ) {
          edges {
            node {
              excerpt(format: HTML, pruneLength: 400)
              id
              fields {
                slug
              }
              frontmatter {
                title
                templateKey
                date(formatString: "DD.MM.YYYY")
                featuredpost
              }
            }
          }
        }
      }
    `}
    render={(data, count) => <BlogLatest data={data} count={count} />}
  />
);
